import * as React from "react";
import { CommonLibraryGitCredentialsOverview, CommonLibraryGitCredentialsTopics } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonLibraryGitCredentialsViews";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
export const LibraryGitCredentialRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.gitCredential.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryGitCredentialsOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryGitCredentialsTopics />;
    },
};
